import { useCallback } from 'react';
import { baseUrl } from '../services/api';
import { authHeaderToken } from '../services/auth-header';

export const openUrlInNewTab = (url: string) => {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    throw new Error('Invalid document URL');
  }

  window.open(url, '_blank', 'noopener,noreferrer');
};

export const useDocumentDownload = () => {
  const downloadDocument = useCallback(async (docId: number) => {
    const token = authHeaderToken();
    const response = await fetch(`${baseUrl}documents/${docId}/download`, {
      headers: { 'x-access-token': token ?? '' }
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.message ?? 'Download failed');
    }

    const { url } = await response.json();
    if (!url) throw new Error('Download URL missing');

    openUrlInNewTab(url);
  }, []);

  return { downloadDocument };
};
